import { render, staticRenderFns } from "./drawer_salesXimei.vue?vue&type=template&id=c230f2ca&scoped=true&"
import script from "./drawer_salesXimei.vue?vue&type=script&lang=js&"
export * from "./drawer_salesXimei.vue?vue&type=script&lang=js&"
import style0 from "./drawer_salesXimei.vue?vue&type=style&index=0&id=c230f2ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c230f2ca",
  null
  
)

export default component.exports